import { render, staticRenderFns } from "./p-saves.vue?vue&type=template&id=6d2bc01f&scoped=true"
import script from "./p-saves.vue?vue&type=script&lang=js"
export * from "./p-saves.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d2bc01f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6d2bc01f')) {
      api.createRecord('6d2bc01f', component.options)
    } else {
      api.reload('6d2bc01f', component.options)
    }
    module.hot.accept("./p-saves.vue?vue&type=template&id=6d2bc01f&scoped=true", function () {
      api.rerender('6d2bc01f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/mprofiles/views/find-user/p-saves.vue"
export default component.exports